import { i18n } from '@/locale'
import moment from 'moment'
function formatRange (range) {
  return `${ formatTime(range.startHour) } - ${ formatTime(range.endHour) }`
}
function formatTime (duration) {
  var minutes = Math.floor((duration / (1000 * 60)) % 60)
  var hours = Math.floor((duration / (1000 * 60 * 60)) % 24)

  hours = (hours < 10) ? '0' + hours : hours
  minutes = (minutes < 10) ? '0' + minutes : minutes
  
  return hours + ':' + minutes
}

function colonHourToMs (colonHour) {
  return colonHour ? parseInt(colonHour.split(':')[0]) * 60 * 60 * 1000 + parseInt(colonHour.split(':')[1]) * 60 * 1000 : null
}

function formatDuration ({ ms, extended }) {
  const millisecond = ((((ms % 31536000000) % 86400000) % 3600000) % 60000) % 0
  if (ms > 0) {
    const years = Math.floor(ms / 31536000000)
    const days = Math.floor((ms % 31536000000) / 86400000)
    const hours = Math.floor(((ms % 31536000000) % 86400000) / 3600000)
    const minutes = Math.floor((((ms % 31536000000) % 86400000) % 3600000) / 60000)
    const seconds = Math.floor(((((ms % 31536000000) % 86400000) % 3600000) % 60000) / 60000)
    var y = years ? `${ years }${ i18n.t('measurement_unit.year') }` : ''
    var d = days ? `${ days }${ i18n.t('measurement_unit.day') }` : ''
    var h = hours ? `${ hours }${ i18n.t('measurement_unit.h') }` : ''
    var m = minutes ? `${ minutes }${ i18n.t('measurement_unit.min') }` : ''
    if (extended) {
      y = years ? `${ i18n.tc('measurement_unit.year_quantified', years) }` : ''
      d = days ? `${ i18n.tc('measurement_unit.day_quantified', days) }` : ''
      h = hours ? `${ i18n.tc('measurement_unit.hour_quantified', hours) }` : ''
      m = minutes ? `${ i18n.tc('measurement_unit.minute_quantified', minutes) }` : ''
    } else {
    }
    const s = seconds ? `${ seconds }${ i18n.t('measurement_unit.s') }` : ''
    const msds = millisecond ? `${ millisecond }${ i18n.t('measurement_unit.ms') }` : ''
    const str = y + d + h + m + s + msds
    return str
  }
}

export {
  formatRange,
  formatTime,
  colonHourToMs,
  formatDuration,
}
